import { createContext, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";

import { getToken, getUser } from "auth/storage";
import { isTokenExpired } from "auth/token";
import * as authService from "auth/authService";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUserState] = useState(() => getUser());

  const login = async (email, password) => {
    const data = await authService.login(email, password);
    setUserState(data.user);
    return data;
  };

  const logout = () => {
    authService.logout();
    setUserState(null);
  };

  // `user` is the only piece of React state; token reads are intentionally fresh.
  const value = useMemo(() => {
    const token = getToken();
    return {
      user,
      isAuthenticated: Boolean(token) && !isTokenExpired(token),
      login,
      logout,
    };
  }, [user]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
